import videojs from 'video.js'

export default function loadVideoCover(
  src?: string,
): Promise<[string, number, number] | undefined> {
  if (!src) return Promise.resolve(undefined)

  return new Promise((resolve) => {
    const video = document.createElement('video')
    video.preload = 'auto'
    video.setAttribute('width', '640')
    video.setAttribute('height', '360')

    const videoPlayer = videojs(video, {
      controls: false, // 不需要用户控制
      autoplay: false,
      preload: 'auto',
    })
    videoPlayer.src({
      src: src,
      type: 'application/x-mpegURL',
    })

    videoPlayer.ready(() => {
      videoPlayer.on('loadeddata', () => {
        // 跳转到指定时间（这里是1秒）
        videoPlayer.currentTime(1)

        // 延迟获取视频帧，确保画面渲染完成
        setTimeout(() => {
          const canvas = document.createElement('canvas')
          const context = canvas.getContext('2d')

          canvas.width = video.videoWidth
          canvas.height = video.videoHeight

          // 从视频元素绘制到 canvas
          context!.drawImage(video, 0, 0, canvas.width, canvas.height)

          // 你可以在这里将截图保存为图片
          resolve([
            canvas.toDataURL('image/png'),
            video.videoWidth,
            video.videoHeight,
          ]) // 输出 Base64 图片
        }, 500) // 延迟 500ms 确保画面稳定
      })
    })
  })
}
